import { useEffect, useMemo, useState } from 'react';
import { batch } from 'react-redux';
import { userGroupManagement } from 'src/services/UserGroupManagement';
import { clearRoles, setRoles } from 'src/store/Roles';
import { setSite, setSiteRole } from 'src/store/Site';
import { setConfirmExitValue } from 'src/store/confirmExitValue';
import { setConfirmExitPopupVal } from 'src/store/confirmPopupVal';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { setSelectedSite } from 'src/store/siteselected';
import { Translation } from 'src/types/Translation';
import { useTranslations } from '../hooks/useTranslations';

export const useSite = () => {
  const dispatch = useAppDispatch();
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const selectedStudy = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const groupName: any = useAppSelector(state => state.site.selectedSiteRole);
  const siteClicksData: any = useAppSelector(state => state.site.siteClicksData);
  const roles: any = useAppSelector(state => {
    return state.roles.roles;
  });
  const siteTxt = useTranslations({} as Translation, {}, 'siteTxt');
  const [prevClickedSite, setprevClickedSite] = useState<any>(null);

  const confirmexitvalue: any = useAppSelector(state => state.confirmexitvalue);

  const siteRolePermissionResult = useMemo(
    () => userGroupManagement.endpoints.getClientRoles.select({ group_name: groupName, client_name: 'ctms-ui' }),
    [groupName]
  );

  const tsdaRoles = useMemo(
    () => userGroupManagement.endpoints.getClientRoles.select({ group_name: groupName, client_name: 'tsda-ui' }),
    [groupName]
  );

  const {
    isLoading: siteRolePermLoading,
    data: siteRolePermData,
    error: siteRolePermError
  } = useAppSelector(siteRolePermissionResult);

  const { isLoading: tsdaRolesLoading, data: tsdaRolesData, error: tsdaRolesError } = useAppSelector(tsdaRoles);

  useEffect(() => {
    if (groupName?.length > 0) {
      const result = dispatch(
        userGroupManagement.endpoints.getClientRoles.initiate({ group_name: groupName, client_name: 'ctms-ui' })
      );
      const tempresult = dispatch(
        userGroupManagement.endpoints.getClientRoles.initiate({ group_name: groupName, client_name: 'tsda-ui' })
      );
      result.unsubscribe();
      tempresult.unsubscribe();
    }
  }, [dispatch, groupName]);

  useEffect(() => {
    if (groupName?.length > 0 && siteRolePermData && !siteRolePermLoading && !siteRolePermError) {
      const rolesArr: any = [];
      siteRolePermData.forEach((item: any) => {
        rolesArr.push(item.name);
      });
      dispatch(setRoles([...roles, ...rolesArr]));
    }
  }, [groupName, siteRolePermData, siteRolePermLoading, siteRolePermError]);

  useEffect(() => {
    if (groupName?.length > 0 && tsdaRolesData && !tsdaRolesLoading && !tsdaRolesError) {
      const rolesArr: any = [];
      tsdaRolesData.forEach((item: any) => {
        rolesArr.push(item.name);
      });
      dispatch(setRoles([...roles, ...rolesArr]));
    }
  }, [groupName, tsdaRolesData, tsdaRolesLoading, tsdaRolesError]);

  useEffect(() => {
    if (siteRolePermError && !siteRolePermLoading && siteRolePermData) {
      dispatch(clearRoles());
    }
    if (tsdaRolesError && !tsdaRolesLoading && tsdaRolesData) {
      dispatch(clearRoles());
    }
  }, [siteRolePermError, siteRolePermLoading, siteRolePermData, tsdaRolesData, tsdaRolesLoading, tsdaRolesError]);

  const updateSiteAndSiteStudyPersonal = (site: any, role: any) => {
    // if (site) {
    batch(() => {
      dispatch(setSite(site));
      dispatch(setSiteRole(role));
      setSelectedSite(dispatch, site); //*** Need to update */
      setConfirmExitValue(dispatch, false); //*** Need to update */
    });
    //}
  };

  const close = (val: string | null, role: string | null) => {
    if (confirmexitvalue.confirmexitvalue === true) {
      setConfirmExitPopupVal(dispatch, true); //*** Need to update */
    } else {
      updateSiteAndSiteStudyPersonal(val, role);
    }
  };

  return {
    selectedSite,
    confirmexitvalue,
    dispatch,
    close,
    siteTxt: siteTxt.siteTxt,
    siteClicksData,
    prevClickedSite,
    setprevClickedSite,
    selectedCountry,
    selectedStudy
  };
};
